module.exports = __webpack_public_path__ + "static/hometow-bg-60b05e960ecad67cd087542d1274e174.jpg";